import * as TypeGraphQL from "type-graphql";
export var AssetType;
(function (AssetType) {
    AssetType["STOCK"] = "STOCK";
    AssetType["ETF"] = "ETF";
    AssetType["MUTUAL_FUND"] = "MUTUAL_FUND";
    AssetType["CRYPTOCURRENCY"] = "CRYPTOCURRENCY";
    AssetType["INDEX"] = "INDEX";
    AssetType["COMMODITY"] = "COMMODITY";
    AssetType["CURRENCY"] = "CURRENCY";
    AssetType["OPTION"] = "OPTION";
    AssetType["FUTURE"] = "FUTURE";
    AssetType["BOND"] = "BOND";
    AssetType["WARRANT"] = "WARRANT";
    AssetType["ADR"] = "ADR";
    AssetType["GDR"] = "GDR";
    AssetType["UNIT"] = "UNIT";
    AssetType["RIGHT"] = "RIGHT";
    AssetType["REIT"] = "REIT";
    AssetType["STRUCTURED_PRODUCT"] = "STRUCTURED_PRODUCT";
    AssetType["SWAP"] = "SWAP";
    AssetType["SPOT"] = "SPOT";
    AssetType["FORWARD"] = "FORWARD";
    AssetType["OTHER"] = "OTHER";
})(AssetType || (AssetType = {}));
TypeGraphQL.registerEnumType(AssetType, {
    name: "AssetType",
    description: undefined,
});
//# sourceMappingURL=AssetType.js.map